// eslint-disable-next-line no-restricted-imports
import {
  ThemeOptions,
  Theme as ThemeBase,
  createTheme as createThemeBase,
} from '@mui/material';

import { breakpoints } from './breakpoints';
import { Colors } from './colors';
import { palettes } from './palette';
import { typography } from './typography';

export type PaletteMode = 'dark' | 'light';

/**
 * Generates theme options based on the selected theme mode.
 * @param {PaletteMode} mode - The current theme mode ('light' or 'dark').
 */
const getThemeOptions = (mode: PaletteMode): ThemeOptions => {
  const palette = palettes[mode];
  const defaultTheme = createThemeBase();
  return {
    palette,
    typography,
    breakpoints,
    components: {
      MuiAutocomplete: {
        styleOverrides: {
          paper: {
            border: `1px solid ${Colors.gray300}`,
            boxShadow:
              '0px 1px 11px 0px rgba(56, 77, 108, 0.12), 0px 1px 2px 0px rgba(56, 77, 108, 0.04);',
          },
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            borderRadius: 12,
            boxShadow:
              '0px 1px 11px 0px rgba(56, 77, 108, 0.12), 0px 1px 2px 0px rgba(56, 77, 108, 0.04);',
          },
          list: {
            backgroundColor: palette.selectBg,
            padding: 0,
          },
        },
      },
      MuiMenuItem: {
        defaultProps: {
          disableRipple: true,
        },
      },

      MuiSvgIcon: {
        styleOverrides: {
          root: {
            transition: defaultTheme.transitions.create(['color']),
          },
        },
      },

      MuiBackdrop: {
        styleOverrides: {
          root: {
            backgroundColor: palette.backdropBg,
          },
          invisible: {
            background: 'none',
          },
        },
      },
    },
  };
};

/**
 * Creates a Material-UI theme based on the specified theme mode.
 * @param {PaletteMode} mode - The current theme mode ('light' or 'dark').
 */
export const createTheme = (mode: PaletteMode) =>
  createThemeBase(getThemeOptions(mode));

export type Theme = ThemeBase;
